"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.HtmlOpdFormClear = exports.getHtml = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _ramda = require("ramda");

var _classnames = _interopRequireDefault(require("classnames"));

var _attrs = require("../../utils/attrs");

var _regexps = require("../../constants/regexps");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var styles = {
  "formWrapper": "index__formWrapper",
  "formBtn": "index__formBtn",
  "formBtnCancel": "index__formBtnCancel",
  "formLink": "index__formLink",
  "withoutOpd": "index__withoutOpd",
  "formLabel": "index__formLabel",
  "formLabelRequired": "index__formLabelRequired",
  "formLabelOptional": "index__formLabelOptional",
  "formInput": "index__formInput",
  "formTextarea": "index__formTextarea",
  "formSection": "index__formSection",
  "formSectionRow": "index__formSectionRow",
  "formSectionBtn": "index__formSectionBtn",
  "error": "index__error",
  "compositeError": "index__compositeError",
  "fileInput": "index__fileInput",
  "fileControls": "index__fileControls",
  "formDateSelect": "index__formDateSelect",
  "formMoneySelect": "index__formMoneySelect",
  "amountField": "index__amountField",
  "currencyField": "index__currencyField",
  "imagePreview": "index__imagePreview",
  "dangerBtn": "index__dangerBtn",
  "dangerBtnDisabled": "index__dangerBtnDisabled",
  "fileList": "index__fileList",
  "fileItem": "index__fileItem",
  "downloadButton": "index__downloadButton",
  "downloadButtonDisabled": "index__downloadButtonDisabled",
  "fileButtonGroup": "index__fileButtonGroup",
  "timeIndicator": "index__timeIndicator",
  "modalButtonGroup": "index__modalButtonGroup"
};
var commonStyle = "\n    .opd-html-form {\n        line-height: 20px;\n        margin-bottom: 24px;\n    }\n    .opd-html-form input {\n        border: none;\n        border-bottom: 1px solid #000;\n        font-size: 16px;\n        pointer-events: auto;\n        margin: 4px 0;\n        appearance: none;\n        -moz-appearance: none;\n        -webkit-appearance: none;\n    }\n    .opd-html-form label {\n        pointer-events: auto;\n    }\n    .opd-html-form input:focus {\n        outline: none;\n    }\n    .opd-html-form.submitted input:invalid {\n        border-bottom: 1px solid red;\n    }\n    .opd-html-form label{\n        cursor: pointer;\n    }\n    .opd-html-form input[type=\"checkbox\"] {\n        position: relative;\n        margin-right: 8px;\n        margin-bottom: -2px;\n        border: 1px solid #ccc;\n        appearance: none;\n        width: 18px;\n        height: 18px;\n        border-radius: 2px;\n    }\n    .opd-html-form input[type=\"checkbox\"]:checked {\n        background: #3a70bb;\n        border-color: #3a70bb;\n    }\n    .opd-html-form input[type=\"checkbox\"]:checked:before {\n        background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAA21JREFUaEPtmF3oVUUUxX+rsOiD6MMgiSQMIYIyEE3wIzERBQmzIKiwBCnxwUTEerAX66UkwkwoiCALIujLIKO0IoIKKnqoXrTHfMgHQ8oEy5ZsHU2u556Zc/733v/9w53Xs2Zmrb337DVzxAQfmuD8GQkY7wyOMjDKQEcEbC8G3gR2As9Icl2QhqqEbN8A/ABcm0jvAR6S9Ec3EUMjwPYk4AtgbgfZX4GVkn6qEjFMAl4GHusS6b+ANZLe7vw+FAJsrwJezzSEOAv3SXrvXNy4C7A9A/gGuCQj4AQwX1Jgz45xFWD7SuB74KaCdvykpGeHpoRsR/DeBe4pIP8hsKKqpY5bBmxvAZ4uIH8AmCXpyNB0Idt3AZ8AF2YEHIu2KunHofGBCrOq0/CIpNruNNASsn0x8FWUREHp7JC0PocbtIBXgEdzpIBvgTslHc9hBybA9oPpkpbjdAiYKem3HDC+D0SA7duSWV1aYFbLJO0tIT8QAbavAr4rNKsnJD1XSr5IQDKctVGXde2salPbFwC7geUFpN4H7s3d/xs7se1twCbgKHC3pM8LyJyC2H4K2FqArzWruvm1Z8B2OGU45pnxd1i/pE9zpBqYVQRmjqSfc2s2cmLbG4AXKiZFa7tf0gfdNrQ9Nb2sJheQeljSrgJcJaQyA7bXAS/VdKl/gAckvdO5akOzelHS423JVx5i20uAj4E4gHXjX2C1pHiAnx22S83qa2ChpAhG63FeBmwvAKIPX1Sw6n/xDJT0ajq0q4HXCub9nszqYAG2FtKthJalu3rulXSKN7AxPcgjqj03qzoFXbtQ6iLRwy8rjNJh4OoC7GZJ0Zp7MnJtdB7wEXBFT3Y7bWrRhmt/VjXZK3sXsj0zPT6uabJwBXY/MLvby6rt2lkB6XDeAuwDprTcKMzqDkm/tJzfdVqRgCTi5iTi+hYkVkl6o8W87JRiAUnEjcBnwLTsyv8DtksKV+/LaCQgiYhrQpTT9AJG8RMqzCr7sipYqxLSWEAScR0QF7pbazbumVnViWslIImIX+Ah4vaKDeKasVjSl20jWzqvtYAkIn4Nxr1pTseGmyQ9X0piLLgxCUgiLk+vrkWJSM/Nqi8ldO6ituO68RYQZrdU0p9jiWqTuWPOQJPN+oEdCehHVJusOcpAk2j1AzvhM3ASm876Mart7QEAAAAASUVORK5CYII=\");\n        position: absolute;\n        left: 0;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        content: '';\n        display: table-cell;\n        border-top: 0;\n        border-left: 0;\n        width: 16px;\n        height: 16px;\n        background-size: 12px;\n        background-repeat: no-repeat;\n        background-position: center;\n    }\n    .opd-html-form input[type=\"checkbox\"]:required::after {\n        content: \"*\";\n        color: red;\n        top: -6px;\n        right: -8px;\n        position: absolute;\n    }\n    .opd-html-form.submitted input[type=\"checkbox\"]:invalid {\n        border-color: red;\n    }\n    .opd-html-form > div > div {\n        margin: 4px 0;\n    }\n    .opd-html-form > div p {\n        display: inline-block;\n        margin: 4px 0;\n    }\n    .opd-html-form > div p + p {\n        display: block;\n    }\n";

var getHtml = function getHtml(body, customStyles) {
  return "\n    <!DOCTYPE html>\n    <html lang=\"en\">\n        <head>\n            <meta charset=\"UTF-8\">\n            <meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\">\n            <title>OPD</title>\n            <style>\n                ".concat(customStyles || '', "\n                ").concat(commonStyle, "\n                .opd-html-form {\n                    font-family: Arial;\n                    font-size: 16px;\n                }\n                .opd-html-form input,\n                .opd-html-form label {\n                    pointer-events: none;\n                }\n                .opd-html-form input[type=\"checkbox\"]:required::after {\n                    content: \"\";\n                }\n            </style>\n        </head>\n        <body>\n            <div style=\"margin: 10px auto; max-width: 1080px;\">\n                ").concat(body, "\n            </div>\n        </body>\n    </html>\n");
};

exports.getHtml = getHtml;
var TEXT_FIELDS = ['text', 'email', 'phone', 'date'];
var SELECT_FIELDS = ['dictionary', 'company_dictionary', 'list', 'city', 'country', 'region', 'money'];
var OPD_DATA_CHECKBOXES = {
  'accept': 'accept',
  'acceptCheckbox': 'accept',
  'opdAccept': 'accept',
  'purpose': 'purpose',
  'purposeCheckbox': 'purpose',
  'opdPurpose': 'purpose',
  'mailing': 'mailing',
  'mailingCheckbox': 'mailing',
  'transmission': 'transmission',
  'transmissionCheckbox': 'transmission'
};

var HtmlOpdForm = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(HtmlOpdForm, _Component);

  var _super = _createSuper(HtmlOpdForm);

  function HtmlOpdForm() {
    var _this;

    (0, _classCallCheck2["default"])(this, HtmlOpdForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      submitted: false,
      value: null
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setValues", function () {
      var values = _this.props.getOpdValues();

      var inputs = _this.form.querySelectorAll('input');

      (0, _ramda.forEach)(function (input) {
        var value = (0, _ramda.trim)("".concat((0, _ramda.path)([input.name], values) || ''));

        if (value) {
          var field = (0, _ramda.find)((0, _ramda.propEq)('field', input.name), _this.props.formFields);

          if (!field || (0, _ramda.includes)(field.type, TEXT_FIELDS)) {
            input.value = value;
            input.setAttribute('value', value);
          } else if (field && (0, _ramda.includes)(field.type, SELECT_FIELDS)) {
            var selectValue = (0, _ramda.path)(['settings', 'multiple'], field) ? (0, _ramda.path)(['settings', 'checkboxes'], field) ? (0, _ramda.join)(', ', (0, _ramda.map)(function (el) {
              return (0, _ramda.path)(['innerHTML'], el);
            }, document.querySelectorAll("#field-".concat(input.name, " .rc-checkbox-checked + .checkbox-label")))) : (0, _ramda.join)(', ', (0, _ramda.map)(function (el) {
              return (0, _ramda.path)(['innerHTML'], el);
            }, document.querySelectorAll("#field-".concat(input.name, " .jobot-forms-rc-select-selection-item-content")))) : (0, _ramda.path)(['settings', 'checkboxes'], field) ? (0, _ramda.path)(['innerHTML'], document.querySelector("#field-".concat(input.name, " .rc-checkbox-checked + .radio-label"))) : (0, _ramda.path)(['innerHTML'], document.querySelector("#field-".concat(input.name, " .jobot-forms-rc-select-selection-item")));

            if (field.type === 'money') {
              var inputValue = document.querySelector("#field-".concat(input.name, " input#").concat(input.name)).value;
              var moneyValue = "".concat(inputValue || '', " ").concat(selectValue || '');
              input.value = moneyValue;
              input.setAttribute('value', moneyValue);
            } else if (selectValue) {
              input.value = selectValue;
              input.setAttribute('value', selectValue);
            }
          }
        }
      }, inputs);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "scrollToInvalid", function () {
      var invalidInput = document.querySelector('.opd-html-form input:invalid');
      var container = document.querySelector('.react-responsive-modal-overlay');

      if (invalidInput) {
        invalidInput.focus({
          preventScroll: true
        });
        container.scrollTo({
          top: invalidInput.getBoundingClientRect().top + container.scrollTop - 10,
          behavior: 'smooth'
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onSubmit", function (formProps) {
      var htmlOpdStyles = _this.props.htmlOpdStyles;
      var form = (0, _ramda.path)(['form'], formProps);

      var inputs = _this.form.querySelectorAll('input');

      var valid = (0, _ramda.all)(function (input) {
        if (input.type === 'email' && !_regexps.EMAIL_EXPERIUM.test(input.value)) {
          input.setCustomValidity('Incorrect email');
          return false;
        } else {
          input.setCustomValidity('');
        }

        return input.validity.valid;
      }, inputs);

      _this.setState(function () {
        return {
          submitted: true
        };
      }, function () {
        return _this.scrollToInvalid();
      });

      if (valid) {
        var values = {};
        (0, _ramda.forEach)(function (input) {
          if (input.type === 'checkbox') {
            if (input.checked) {
              input.setAttribute('checked', input.checked);
            } else {
              input.removeAttribute('checked');
            }
          } else {
            input.setAttribute('value', input.value);
            var field = (0, _ramda.find)((0, _ramda.propEq)('field', input.name), _this.props.formFields);

            if (field && (0, _ramda.includes)(field.type, TEXT_FIELDS)) {
              form.change(input.name, input.value);
            }
          }

          var separateField = input.getAttribute('data-separate-field');

          if (separateField) {
            var value = input.type === 'checkbox' ? input.checked : input.value;
            var id = OPD_DATA_CHECKBOXES[separateField];
            values[id] = value;
            form.change(separateField, value);
          }

          var fixedField = OPD_DATA_CHECKBOXES[input.getAttribute('id')];

          if (fixedField) {
            var _value = input.type === 'checkbox' ? input.checked : input.value;

            values[separateField] = _value;
          }
        }, inputs);

        _this.props.onSubmit(getHtml(_this.form.innerHTML, htmlOpdStyles), values);
      }
    });
    return _this;
  }

  (0, _createClass2["default"])(HtmlOpdForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var value = this.props.value;

      if (value && (0, _ramda.is)(String, value.htmlContent)) {
        var el = this.valueHtml.querySelector('.opd-html-form');
        this.setState({
          value: el ? el.innerHTML : null
        });
      } else {
        this.setValues();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          formProps = _this$props.formProps,
          t = _this$props.t,
          htmlAttrs = _this$props.htmlAttrs,
          htmlOpdStyles = _this$props.htmlOpdStyles,
          onClose = _this$props.onClose,
          acceptBtn = _this$props.acceptBtn;
      var html = this.state.value || this.props.html;
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        ref: function ref(node) {
          return _this2.valueHtml = node;
        },
        style: {
          display: 'none'
        },
        dangerouslySetInnerHTML: {
          __html: (0, _ramda.path)(['value', 'htmlContent'], this.props)
        }
      }), /*#__PURE__*/_react["default"].createElement("style", null, htmlOpdStyles || '', commonStyle), /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({
        onClick: onClose,
        type: "button",
        className: "form-button react-responsive-modal-closeButton pda-modal-close-button",
        "data-testid": "close-button"
      }, (0, _attrs.getAttrs)('opdClose', htmlAttrs)), /*#__PURE__*/_react["default"].createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "28",
        height: "28",
        viewBox: "0 0 36 36",
        "data-testid": "close-icon"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"
      }))), /*#__PURE__*/_react["default"].createElement("form", {
        className: "personalDataAgreementForm",
        ref: function ref(node) {
          return _this2.form = node;
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('opd-html-form', {
          submitted: this.state.submitted
        }),
        dangerouslySetInnerHTML: {
          __html: html
        }
      })), /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({
        className: "".concat(styles.formBtn, " form-button"),
        type: "button",
        onClick: function onClick() {
          return _this2.onSubmit(formProps);
        }
      }, (0, _attrs.getAttrs)('opdAccept', htmlAttrs)), acceptBtn || t('opdFormAccept'))));
    }
  }]);
  return HtmlOpdForm;
}(_react.Component);

var HtmlOpdFormClear = /*#__PURE__*/function (_Component2) {
  (0, _inherits2["default"])(HtmlOpdFormClear, _Component2);

  var _super2 = _createSuper(HtmlOpdFormClear);

  function HtmlOpdFormClear() {
    (0, _classCallCheck2["default"])(this, HtmlOpdFormClear);
    return _super2.apply(this, arguments);
  }

  (0, _createClass2["default"])(HtmlOpdFormClear, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value && !prevProps.open && !(0, _ramda.equals)(prevProps.values, this.props.values)) {
        this.props.onSubmitHtml();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return HtmlOpdFormClear;
}(_react.Component);

exports.HtmlOpdFormClear = HtmlOpdFormClear;

var _default = (0, _reactI18next.withTranslation)()(HtmlOpdForm);

exports["default"] = _default;